/**
 * Created by calhosh on 7/17/2017.
 */

/**
 * loads data from session storage for a given key.
 * @param {string} key - key to get from session storage
 * @returns {object} the object from session storage
 */
export const loadStorage = (key) => {
	try {
		const serializedState = sessionStorage.getItem(key);
		if (serializedState === null) {
			return undefined;
		}
		return JSON.parse(serializedState);
	} catch (err) {
		return undefined;
	}
};

/**
 * loads data from session storage for a given key.
 * @param {string} key - key to add to session storage
 * @param {object} state - the state to store
 */
export const saveStorage = (key, state) => {
	try {
		const serializedState = JSON.stringify(state);
		sessionStorage.setItem(key, serializedState);
	} catch (err) {
		//ignore
	}
};

/**
 * clears data from session storage for a given key.
 * @param {string} key - key to get from session storage
 */
export const clearItem = (key) => {
	try {
		sessionStorage.removeItem(key);
	} catch (err) {
		// ignore
	}
};
